import React from "react";
import { Link } from "react-router-dom";
import { Instagram, MessageCircle, Zap } from "lucide-react";
import { useContent } from "../lib/content";

export default function Footer() {
  const { c } = useContent();
  return (
    <footer className="mt-32 border-t border-neutral-800 bg-black">
      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 py-12">
        <div className="grid lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Zap className="w-5 h-5 text-neon"/>
              <span className="font-display text-xl tracking-tighter">{c.brand_part1}<span className="text-neon">{c.brand_part2}</span></span>
            </div>
            <p className="text-neutral-500 text-sm font-body whitespace-pre-line" data-testid="footer-tagline">{c.footer_tagline}</p>
          </div>
          <div>
            <div className="label-mono mb-3">NAVIGA</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-neutral-300 hover:text-neon">{c.nav_events}</Link></li>
              <li><Link to="/tavoli" className="text-neutral-300 hover:text-neon">{c.nav_tables}</Link></li>
              <li><Link to="/carpooling" className="text-neutral-300 hover:text-neon">{c.nav_carpool}</Link></li>
              <li><Link to="/affiliazione" className="text-neutral-300 hover:text-neon">{c.nav_affiliation}</Link></li>
            </ul>
          </div>
          <div>
            <div className="label-mono mb-3">INFO</div>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contatti" className="text-neutral-300 hover:text-neon">{c.faq_title}</Link></li>
              <li><Link to="/contatti" className="text-neutral-300 hover:text-neon">{c.nav_contacts}</Link></li>
              <li><Link to="/gallery" className="text-neutral-300 hover:text-neon">{c.nav_gallery}</Link></li>
            </ul>
          </div>
          <div>
            <div className="label-mono mb-3">SOCIAL</div>
            <div className="flex gap-3">
              <a href={`https://wa.me/${c.whatsapp_number || ""}`} target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-neutral-700 hover:border-neon hover:text-neon flex items-center justify-center text-neutral-300" data-testid="footer-whatsapp"><MessageCircle className="w-4 h-4"/></a>
              <a href={`https://instagram.com/${c.instagram_handle || ""}`} target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-neutral-700 hover:border-neon hover:text-neon flex items-center justify-center text-neutral-300" data-testid="footer-instagram"><Instagram className="w-4 h-4"/></a>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-neutral-800 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-neutral-600 font-mono tracking-widest">
          <div data-testid="footer-copyright">{c.footer_copyright}</div>
          <div>MADE WITH <span className="text-alert">█</span> {c.footer_made_in}</div>
        </div>
      </div>
    </footer>
  );
}
